import { NewPeriodSelectorIntervalType } from '../../enums/newPeriodSelectorIntervalType';
import { NewPeriodFilter } from './newPeriodFilter';

export class NewCalendarPeriodFilter extends NewPeriodFilter {
  periodIntervalType = NewPeriodSelectorIntervalType.Calendar;
  startDate: Date;
  endDate: Date;
}
